import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { useComponentSize } from 'Util/Hooks';

import { Box } from '../../../Base';
import VideoBox from '../VideoBox';
import { VIDEO_PROVIDER } from '../constant';
import { VIDEO_BOX_VARIANTS } from '../VideoBoxWrapper';

const SkooldioVideoBox = ({ title, type, value, isVideoJsControl, ...videoProps }) => {
  const videoBoxWrapperRef = useRef();
  const videoBoxWrapperSize = useComponentSize(videoBoxWrapperRef);

  const getVideoSize = ({ width }) => {
    if (width <= 225) return 'size-small';
    else if (width <= 390 && width > 225) return 'size-medium';
    return 'size-large';
  };

  return (
    <Box
      className={`responsive-width ${getVideoSize(videoBoxWrapperSize)}`}
      width={'100%'}
      bg="black"
      ref={videoBoxWrapperRef}
      style={{ overflow: 'hidden' }}
    >
      <VideoBox
        variant={VIDEO_BOX_VARIANTS.FIXED_SIZE}
        isVideoJsControl
        title={title}
        type={type}
        value={value}
        {...videoProps}
      />
    </Box>
  );
};

SkooldioVideoBox.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.shape({
    provider: PropTypes.oneOf(Object.values(VIDEO_PROVIDER)),
    videoId: PropTypes.string,
    url: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    duration: PropTypes.number,
  }),
  isVideoJsControl: PropTypes.bool,
};

export default SkooldioVideoBox;
